// src/pages/SubscriptionSuccessPage.tsx
// Public success page shown after successful Stripe subscription payment

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Loader2 } from 'lucide-react';

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/home');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAFAFA] via-white to-[#18365E]/5 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* DVA Logo */}
        <div className="text-center mb-8">
          <span className="text-3xl font-bold text-[#18365E] tracking-tight">DVA</span>
        </div>

        {/* Success Card */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />

          <h1 className="text-2xl font-bold text-[#18365E] text-center mb-3">
            Subscription Activated!
          </h1>

          <p className="text-center text-[#717182] mb-6">
            Your DVA Pro subscription is now active. You'll be redirected to your Pro dashboard in a moment...
          </p>

          <div className="flex items-center justify-center gap-2 mb-6">
            <Loader2 className="w-4 h-4 animate-spin text-[#18365E]" />
            <span className="text-sm text-[#717182]">Redirecting in {countdown}s</span>
          </div>

          <button
            onClick={() => navigate('/home')}
            className="w-full py-3 bg-[#FF6E4C] text-white rounded-xl font-semibold hover:bg-[#ff5a3a] transition-all"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
